
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';


import { Lead, Place } from 'shared/topchef.types';
import PublicLeadContent from 'pages/shared/public-lead-content/PublicLeadContent';

export interface FollowedLeadDetailsFeesRejectedProps {
  loggedInPlace: Place,
  currentLead: Lead,
}

const FollowedLeadDetailsFeesRejected = (props: FollowedLeadDetailsFeesRejectedProps) => {

  console.log("je suis dans le FollowedLeadDetailsFeesRejected");

  const { t } = useTranslation();
  const navigate = useNavigate();

  const backToFollowedLeads = async () => {
    navigate('/places/leads/followed');
  };

  return (
    <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">{t('common.addBrief')}</a></li>
        </ul>
      </div>
       
      <PublicLeadContent publicLead={props.currentLead} />

      <div className="text-center">
        <div className="text-center btn-list">
          <button className="btn btn-primary m-3" onClick={backToFollowedLeads}>{t('followedLead.returnToBriefs')}</button>
          <p>{t('followedLead.lochallHandles')}</p>
        </div>
      </div>
    </div>
  );

}


export default FollowedLeadDetailsFeesRejected;
